import * as React from "react";
import i18next from "i18next";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { PROTECTED_ROUTES } from "src/constants/Navigation";

import useRoutes from "src/hooks/useRoutes";

const LINK_TO_ROUTE_RESOLVER = {
  [i18next.t("category.categoryManagement")]: PROTECTED_ROUTES.CATEGORY,
  [i18next.t("course.courseCatalogue")]: PROTECTED_ROUTES.COURSE,
  [i18next.t("questions.questionCatalogue")]: PROTECTED_ROUTES.QUESTIONS,
  [i18next.t("assessment.assessments&Exams")]: PROTECTED_ROUTES.ASSIGNMENT,
  [i18next.t("student.studentCatalogue")]: PROTECTED_ROUTES.STUDENT,
  // "Bulk creating using GPT": PROTECTED_ROUTES.BULK_QUESTIONS_LISTING,
};

const Heading: React.FC<{ title: string; routes?: Array<string> }> = ({
  title,
  routes,
}) => {
  const { navigateTo } = useRoutes();

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    item: string
  ) => {
    event.preventDefault();
    const pathname = LINK_TO_ROUTE_RESOLVER[item] ?? -1;
    navigateTo(pathname);
  };

  const breadcrumbs = [];
  routes.forEach((item, idx) => {
    if (idx < routes.length - 1) {
      breadcrumbs.push(
        <Link
          key={idx}
          color="inherit"
          underline="hover"
          sx={{ cursor: "pointer" }}
          onClick={(e) => handleClick(e, item)}
        >
          {item}
        </Link>
      );
      return;
    } else {
      breadcrumbs.push(<span key={idx}>{item}</span>);
    }
  });

  return (
    <Box className="breadcrumb-wrap">
      <Typography variant="h2" className="header-title">
        {title}
      </Typography>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Box>
  );
};

export default Heading;
